import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getTraductions } from './api'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'fr', // set locale
  fallbackLocale: 'fr',
  messages: {} // set locale messages
})

const loadedLanguages = false

export function setI18nLanguage (lang) {
  i18n.locale = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync() {
  if(!loadedLanguages){
    return getTraductions().then(
      res => {
        for(var locale in res.data){
          i18n.setLocaleMessage(locale, res.data[locale])
        }
        setI18nLanguage("fr")
      }
    )
  }
  return Promise.resolve()
  
}